import React, { Component, createContext } from 'react';
import { Immocom } from '../specifique/immocom';

export const ImmocomContext = createContext();

class ImmocomProvider extends Component {

    static defaultState = {
        messages: [], // Exemple : { id: 1, message: "Chargement...", type: "loading" }
    };

    constructor(props) {
        super(props);
        this.state = { ...ImmocomProvider.defaultState };
    };

    _addMessage = (type, message) => {
        const id = Math.random().toString(16).slice(2);
        this.setState(prevState => {
            const messages = [...prevState.messages, { id, message, type }];
            return { messages };
        });
        return id;
    };

    _dismissAllMessages = () => {
        this.setState({ ...ImmocomProvider.defaultState });
    };

    _dismissMessage = (id) => {
        this.setState(prevState => {
            const messages = prevState.messages.filter(message => message.id !== id);
            return { messages };
        });
    };

    _fetchMessages = (response) => {
        const { codeRetour } = response;
        if (Immocom.estCodeErreurUtilisateurNonAuthentifie(codeRetour)) Immocom.deconnexionEtRedirectionVersLogin();
        else {
            const { errorMessage, infoMessage, successMessage, warningMessage } = response;
            if (!!errorMessage) this._addMessage("error", errorMessage);
            if (!!infoMessage) this._addMessage("info", infoMessage);
            if (!!successMessage) this._addMessage("success", successMessage);
            if (!!warningMessage) this._addMessage("warning", warningMessage);
        }
    };

    render = () => {
        const { children } = this.props;

        return <ImmocomContext.Provider
            value={{
                ...this.state,
                addMessage: this._addMessage,
                dismissAllMessages: this._dismissAllMessages,
                dismissMessage: this._dismissMessage,
                fetchMessages: this._fetchMessages,
            }}
        >
            {children}
        </ImmocomContext.Provider>;
    };

};

export default ImmocomContext;
export { ImmocomProvider };